// extracted by css-extract-rspack-plugin
export default {"rivers":"FeaturesSection-module__rivers__L07CL"};